
import React from 'react';
import { Button } from "@/components/ui/button";
import { Calendar, Phone } from "lucide-react";
import { openGoogleCalendar } from "@/lib/utils";

interface ConsultorioData {
  id: number;
  consultorioId: "paulista" | "mogi" | "suzano";
  name: string;
  address: string;
  city: string;
  cep: string;
  complement: string;
  phone: string;
  googleMapsUrl: string;
  horarios: string[];
  transporte: string[];
  servicos: string[];
  destaces: string[];
}

interface ConsultorioActionsProps {
  consultorio: ConsultorioData;
  onCall: (phone: string) => void;
}

export const ConsultorioActions: React.FC<ConsultorioActionsProps> = ({
  consultorio,
  onCall
}) => {
  return (
    <>
      {/* Ações */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-6 sm:mt-8">
        <Button 
          className="bg-brand-primary hover:bg-brand-primary/90 font-accent shadow-lg w-full"
          onClick={openGoogleCalendar}
        >
          <Calendar className="w-4 h-4 mr-2" />
          Agendar Consulta
        </Button>
        <Button 
          variant="outline" 
          className="border-brand-primary text-brand-primary hover:bg-brand-primary/5 font-accent w-full"
          onClick={() => onCall(consultorio.phone)}
        >
          <Phone className="w-4 h-4 mr-2" />
          <span className="hidden sm:inline">{consultorio.phone}</span>
          <span className="sm:hidden">Ligar</span>
        </Button>
      </div>

      {/* Info adicional */}
      <div className="mt-4 sm:mt-6 p-3 sm:p-4 bg-gray-50 rounded-lg">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-4 text-xs sm:text-sm text-center">
          <span className="text-gray-600">📱 WhatsApp disponível</span>
          <span className="text-gray-600">🅿️ Estacionamento</span>
          <span className="text-gray-600">♿ Acessível</span>
        </div>
      </div>
    </>
  );
};
